import { createAgentPublicLeadFromOrder } from "../../../services/publicSiteLeadsApi";

/**
 * Build CRM dockets URL that opens the Ops chat pane for a lead/order.
 */
export const ADMIN_OPS_INBOX_PATH = "/p/dashboard/admin/operation-requests";

export function buildCrmOpsDocketPath({
  leadId,
  orderId,
  opsType,
  requestId,
  fromOpsInbox = false,
} = {}) {
  const params = new URLSearchParams();
  params.set("tab", "dockets");
  params.set("pane", "ops");
  const lid = String(leadId || "").trim();
  const oid = String(orderId || "").trim();
  const type = String(opsType || "").trim();
  const rid = String(requestId || "").trim();
  if (lid) params.set("leadId", lid);
  if (oid) params.set("orderId", oid);
  if (type) params.set("opsType", type);
  if (rid) params.set("opsRequestId", rid);
  if (fromOpsInbox) params.set("from", "ops-inbox");
  return `/p/dashboard/drafts?${params.toString()}`;
}

/**
 * Ensure a CRM docket exists for the order (or reuse crmLeadId), then return
 * a path into Ops chat.
 */
export async function resolveCrmOpsDocketPath({
  leadId,
  orderId,
  opsType,
  requestId,
  fromOpsInbox = false,
} = {}) {
  const existingLeadId = String(leadId || "").trim();
  if (existingLeadId) {
    return buildCrmOpsDocketPath({
      leadId: existingLeadId,
      orderId,
      opsType,
      requestId,
      fromOpsInbox,
    });
  }

  const oid = String(orderId || "").trim();
  if (!oid) {
    return buildCrmOpsDocketPath({ opsType, requestId, fromOpsInbox });
  }
  try {
    const data = await createAgentPublicLeadFromOrder(oid);
    const resolvedLeadId = data?.lead?.id || data?.id || null;
    if (resolvedLeadId) {
      return buildCrmOpsDocketPath({
        leadId: resolvedLeadId,
        orderId: oid,
        opsType,
        requestId,
        fromOpsInbox,
      });
    }
  } catch {
    /* fall through — Hub can still open dockets list */
  }
  return buildCrmOpsDocketPath({
    orderId: oid,
    opsType,
    requestId,
    fromOpsInbox,
  });
}

/**
 * Navigate into the CRM docket Ops chat for an operation-request row.
 */
export async function navigateToCrmOpsDocket(navigate, item, options = {}) {
  if (typeof navigate !== "function") return;
  const orderId = String(
    item?.orderId ||
      item?.order_id ||
      item?.ldsOrderId ||
      item?.lds_order_id ||
      options.orderId ||
      ""
  ).trim();
  const leadId = String(
    item?.crmLeadId ||
      item?.crm_lead_id ||
      item?.leadId ||
      item?.lead_id ||
      options.leadId ||
      ""
  ).trim();
  const opsType = String(
    item?.requestType || item?.request_type || options.opsType || ""
  ).trim();
  const requestId = String(item?.id || options.requestId || "").trim();
  const fromOpsInbox = Boolean(options.fromOpsInbox);
  const path = await resolveCrmOpsDocketPath({
    leadId: leadId || undefined,
    orderId: orderId || undefined,
    opsType: opsType || undefined,
    requestId: requestId || undefined,
    fromOpsInbox,
  });
  navigate(path, { replace: Boolean(options.replace) });
}
